import { render, staticRenderFns } from "./CasesResume.vue?vue&type=template&id=04dd239f"
import script from "./CasesResume.vue?vue&type=script&lang=js"
export * from "./CasesResume.vue?vue&type=script&lang=js"
import style0 from "./CasesResume.vue?vue&type=style&index=0&id=04dd239f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports